import React, { useState } from 'react';
import { Drawer, Box, Pagination, ButtonGroup } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { FilterProvider, useFilter, initUserFilterValues } from 'contexts/filter';
import { useError } from 'contexts/error';
import { usePaginate } from 'contexts/paginate';
import Index from 'components/space_users/index';
import FilterForm from 'components/space_users/filter_form';
import FilterTags from 'components/filter/tags';
import InfoContainer from 'components/info_container';
import CreateButton from 'components/space_users/button/create';
import PermissionsQuery from 'queries/space/permissions';
import FilterButton from 'components/space_users/button/filter';

const IndexContainer = () => {
  const { page, onPageChange } = usePaginate();
  const setError = useError();
  const { usersFilter, setUsersFilter } = useFilter();
  const [filterVisible, setFilterVisible] = useState(false);
  const [sortBy, setSortBy] = useState('email_asc');
  const {
    data = { space: { adminRole: true }, spacePermissions: { permissions: [], perPage: 10 } },
    loading,
    refetch,
  } = useQuery(PermissionsQuery, {
    variables: {
      ...usersFilter,
      page: page,
      sortBy: sortBy,
    },
    onError: () => {
      setError('error.users.index');
    },
  });

  const onRemove = () => {
    if (page > 1) {
      onPageChange(page - 1);
    } else {
      refetch();
    }
  };

  return (
    <FilterProvider>
      {filterVisible && (
        <Drawer
          anchor="right"
          open={filterVisible}
          onClose={() => {
            setFilterVisible(false);
          }}
        >
          <FilterForm
            initialValues={usersFilter}
            defaultValues={initUserFilterValues}
            onSubmit={(values) => {
              onPageChange(1);
              setUsersFilter(values);
            }}
            onClose={() => {
              setFilterVisible(false);
            }}
          />
        </Drawer>
      )}
      <Box display="flex" justifyContent="flex-end">
        <ButtonGroup>
          <CreateButton onSuccess={refetch} disabled={!data.space.adminRole} />
          <FilterButton
            onClick={() => setFilterVisible(!filterVisible)}
            initUserFilterValues={initUserFilterValues}
            usersFilter={usersFilter}
          />
        </ButtonGroup>
      </Box>
      <FilterTags
        filterValues={usersFilter}
        defaultValues={initUserFilterValues}
        onFilterChange={setUsersFilter}
      />
      <InfoContainer visible={!loading && data.spacePermissions.permissions === 0}>
        <FormattedMessage id="empty.users.title" />
      </InfoContainer>
      <Index
        permissions={data.spacePermissions.permissions}
        onRemove={onRemove}
        sortBy={sortBy}
        onSortChange={setSortBy}
      />
      <Box display="flex" justifyContent="center">
        {data.spacePermissions.permissionsTotalPages > 1 && (
          <Pagination
            count={data.spacePermissions.permissionsTotalPages}
            page={page}
            onChange={(_e, nextPage) => {
              onPageChange(nextPage);
            }}
          />
        )}
      </Box>
    </FilterProvider>
  );
};

export default IndexContainer;
